import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Translate, withTranslate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { combineClassNames } from 'core/css';
import Modal, { ModalBody, ModalHeader } from '../../common/modal/Modal';
import { CA_POSTAL_REGEX, ZIP_REGEX, servicesPath } from '../../constants';
import { withModelInfo } from '../../common/ModelInfoContext';

const validations = {
  US: {
    maxlength: 5,
    pattern: ZIP_REGEX
  },
  CA: {
    maxlength: 7,
    pattern: CA_POSTAL_REGEX
  }
};

const validate = (postalCode, country) => {
  //if (country === 'US') {
  // const url = `${
  //   window.appResources.urls.zipCodeUrl
  // }/${postalCode}.json?brand=${brand}`;

  const url = `${servicesPath}/geo/legacy/en/${country}/${postalCode}`;

  return fetch(url).then(res => res.json());
  //}
  //return Promise.resolve({ zipcode: postalCode });
};

class PostalCodeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      isUpdating: false,
      isDirty: false,
      value: props.initialValue
    };
  }

  onKeyPress = () => {
    this.setState({ hasError: false });
  };

  onFocus = () => {
    const { isDirty } = this.state;
    if (!isDirty) {
      this.setState({
        isDirty: true,
        value: ''
      });
    }
  };

  onChangeValue = event => {
    this.setState({
      value: event.target.value
    });
  };

  onSubmit = event => {
    const { modelInfo, onUpdate, onClose } = this.props;
    const { value } = this.state;
    const { country, brand } = modelInfo;
    const { pattern } = get(validations, country, {});

    event.preventDefault();

    const postalCode = value.replace(/\s/g, '');
    const isValidValue = new RegExp(pattern).test(postalCode);

    if (!isValidValue) {
      this.setState({
        hasError: true
      });
      return;
    }

    this.setState(
      {
        isUpdating: true
      },
      () => {
        validate(postalCode, country, brand).then(
          data => {
            onUpdate(postalCode, data, onClose);
          },
          () => {
            this.setState({
              isUpdating: false,
              hasError: true
            });
          }
        );
      }
    );
  };

  render() {
    const { translate, initialValue, modelInfo, onClose } = this.props;
    const { country } = modelInfo;
    const { hasError, isUpdating, value } = this.state;

    const header = translate('components.postal.code.modal.title');

    const { maxlength } = get(validations, country, {});

    const errorMessage = hasError && (
      <div className="postal-code__error">
        <Translate value="postal.code.error.message" />
      </div>
    );

    return (
      <Modal
        isOpen={true}
        className="postal-code-modal"
        contentLabel={header}
        onRequestClose={onClose}>
        <ModalHeader
          text={header}
          hideClose={!initialValue}
          onClose={onClose}
        />
        <ModalBody>
          <p>
            <Translate value="components.postal.code.modal.header" />
          </p>
          <div className="postal-code">
            <form
              name="postalCode"
              className="postal-code__form"
              onSubmit={this.onSubmit}>
              <label>
                <div className="postal-code__label-text">
                  <Translate value="postal.code" />
                </div>
                <div className="postal-code__input-group">
                  <input
                    value={value}
                    onChange={this.onChangeValue}
                    onFocus={this.onFocus}
                    onKeyPress={this.onKeyPress}
                    className={combineClassNames([
                      'postal-code__input',
                      'stat-search-input',
                      hasError ? 'postal-code__input--error' : ''
                    ])}
                    data-dtm={header}
                    maxLength={maxlength}
                    required
                  />
                  <button
                    className={combineClassNames([
                      'button postal-code__input-button',
                      'stat-button-link',
                      hasError ? 'postal-code__input-button--error' : ''
                    ])}
                    data-dtm={header}
                    id="zipSubmit">
                    <SvgIcon
                      name="postal-submit"
                      className={
                        isUpdating ? 'postal-code__submit-icon--updating' : ''
                      }
                    />
                  </button>
                </div>
              </label>
              {errorMessage}
            </form>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

PostalCodeModal.defaultProps = {
  initialValue: ''
};

PostalCodeModal.propTypes = {
  initialValue: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default withModelInfo(withTranslate(PostalCodeModal));
